<template>
  <div id="location-container">
    <LazyHH4 class="mt-5 mb-4">
      Localisation
    </LazyHH4>

    <div class="row">
      <div class="col-12">
        <div
          ref="$map"
          class="map"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  latitude?: number,
  longitude?: number
}>()

const $map = ref()

onMounted(async () => {
  const { gMapLoader } = useGMap()
  const { Map } = await gMapLoader.importLibrary('maps')
  const { Marker } = await gMapLoader.importLibrary('marker')

  const position = { lat: props.latitude ?? 0, lng: props.longitude ?? 0 }

  const map = new Map($map.value as HTMLElement, {
    zoom: 12,
    center: position
  })

  // eslint-disable-next-line no-new
  new Marker({
    position,
    map,
    optimized: true
  })
})

</script>

<style lang="scss" scoped>
#location-container {
  position: relative;
  margin-bottom: 30px;

  .map {
    width: 100%;
    height: 560px;

    @media (width <= 768px) {
      height: 245px;
      margin: 0 -10px;
      width: calc(100% + 20px);
    }
  }
}
</style>
